// components/FAQs.js
import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    question: "What locations do you help clients buy in?",
    answer:
      "We operate across Australia with a focus on high-growth suburbs in QLD, WA, VIC, SA, and NSW.",
  },
  {
    question: "Do you assist SMSF or trust purchases?",
    answer:
      "Yes! We specialise in structuring SMSF and trust purchases with full guidance on compliance and finance.",
  },
  {
    question: "Do you only work with investors?",
    answer:
      "No — while most of our clients are investors, we also help owner-occupiers and first-home buyers.",
  },
  {
    question: "What makes you different from other buyer’s agents?",
    answer:
      "We go beyond property search — we offer strategic planning, off-market access, due diligence, and long-term support, all backed by data.",
  },
  {
    question: "Do you offer a free consultation?",
    answer:
      "Yes, we offer a no-obligation 15-minute discovery call to understand your goals and how we can help.",
  },
  {
    question: "Can you help with auction bidding?",
    answer:
      "Absolutely. We can bid on your behalf at auctions and guide you through pre-auction offers and negotiation strategies.",
  },
  {
    question: "Do you help interstate or overseas buyers?",
    answer:
      "Yes, we work with both interstate and international clients and handle the entire process remotely if needed.",
  },
  {
    question: "How long does the full process usually take?",
    answer:
      "Depending on your brief and finance readiness, most clients secure a property within 4–8 weeks from onboarding.",
  },
];


const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id="faq" className="bg-white py-16 px-6">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-[#003366] mb-8 text-center">Frequently Asked Questions</h2>
        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="border border-gray-200 rounded-lg p-4 shadow-sm bg-[#f9f9f9] cursor-pointer"
              onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
            >
              <div className="flex justify-between items-center text-[#003366] font-medium">
                {faq.question}
                <ChevronDown className={`transform transition ${openIndex === idx ? "rotate-180" : ""}`} />
              </div>
              {openIndex === idx && (
                <p className="text-sm text-gray-600 mt-2">{faq.answer}</p>
              )}
            </div>
        ))}
        </div>
      </div>
    </section>
  );
};

export default FAQs;
